import React, { useEffect, useState } from 'react';
import { buscarTiposGasto } from '../../services/data';
import { useAutocompletar, BotonLimpiar } from './useAutocompletar';

export default function TipoGastoAutocomplete({ value, tipoId, onChange, disabled }) {
  const [opciones, setOpciones] = useState([]);
  const { abierto, setAbierto, ref, listId, propsInput, limpiar, botonCerrar } = useAutocompletar();
  useEffect(() => {
    if (!abierto) return undefined;
    let vigente = true;
    const t = setTimeout(() => buscarTiposGasto(value).then((r) => { if (vigente) setOpciones(r); }).catch(() => { if (vigente) setOpciones([]); }), 200);
    return () => { vigente = false; clearTimeout(t); };
  }, [value, abierto]);
  const exacto = opciones.find((t) => t.nombre.trim().toLowerCase() === String(value || '').trim().toLowerCase());
  return <div className="prod-auto" ref={ref}>
    <span className="auto-campo">
      <input {...propsInput} value={value || ''} disabled={disabled} maxLength={120} aria-label="Tipo de gasto o pago" className={!disabled && value ? 'auto-con-limpiar' : undefined}
        placeholder="Buscar o escribir tipo" onChange={(e) => { onChange({ tipo: e.target.value, tipoId: null }); setAbierto(true); }} onBlur={() => { if (!tipoId && exacto) onChange({ tipo: exacto.nombre, tipoId: exacto.id }); }} />
      <BotonLimpiar visible={!disabled && !!value} etiqueta="Limpiar tipo" onClick={() => limpiar(() => onChange({ tipo: '', tipoId: null }))} />
    </span>
    {!disabled && value && !tipoId && !abierto && <small className="prod-auto-nuevo">No catalogado: pendiente de revisar</small>}
    {abierto && !disabled && <ul id={listId} role="listbox" className="prod-auto-lista">
          {botonCerrar}
      {opciones.map((t) => <li key={t.id} role="option" aria-selected={t.id === tipoId}><button type="button" onPointerDown={(e) => { e.preventDefault(); onChange({ tipo: t.nombre, tipoId: t.id }); setAbierto(false); }}
        onClick={() => { onChange({ tipo: t.nombre, tipoId: t.id }); setAbierto(false); }}>{t.nombre}</button></li>)}
      {value && !opciones.some((t) => t.nombre.toLowerCase() === value.trim().toLowerCase()) && <li className="prod-auto-libre"><button type="button" onPointerDown={(e) => { e.preventDefault(); setAbierto(false); }} onClick={() => setAbierto(false)}>Usar “{value}” (no catalogado)</button></li>}
    </ul>}
  </div>;
}
